import React, { useEffect, useRef } from "react";
import MessageBubble from "./MessageBubble";

function MessageLoader() {
  return (
    <div className="space-y-4 p-6">
      {[...Array(4)].map((_, i) => (
        <div
          key={i}
          className={`flex items-start gap-2 ${i % 2 === 0 ? "flex-row-reverse" : ""}`}
        >
          <div className="w-8 h-8 bg-gray-200 rounded-full" />
          <div
            className={`h-12 rounded-2xl animate-pulse ${
              i % 2 === 0 ? "bg-gray-300 w-48" : "bg-gray-100 w-56"
            }`}
          />
        </div>
      ))}
    </div>
  );
}

export default function MessageList({ messages, loading, highlightText = "", activeMessageIndex = -1, onComputeMatches }) {
  const chatEndRef = useRef(null);
  const msgRefs = useRef([]);

  // Scroll to bottom on initial load or when messages change and no active search
  useEffect(() => {
    if (!highlightText) {
      chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages, highlightText]);

  // compute which messages contain the highlight text and notify parent
  useEffect(() => {
    const q = (highlightText || "").trim().toLowerCase();
    if (!q) {
      onComputeMatches && onComputeMatches([]);
      return;
    }
    const indexes = [];
    messages.forEach((m, i) => {
      const t = (m.message_text || "").toLowerCase();
      if (t.includes(q)) indexes.push(i);
    });
    onComputeMatches && onComputeMatches(indexes);
  }, [highlightText, messages, onComputeMatches]);

  if (loading) {
    return <MessageLoader />;
  }

  if (messages.length === 0) {
    return (
      <div className="flex-1 flex items-center justify-center text-gray-400 p-6">
        <div className="text-center">
          <svg
            className="w-20 h-20 mx-auto mb-4 text-gray-300"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
            />
          </svg>
          <p>No messages yet</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex-1 overflow-y-auto p-6 space-y-4">
      {messages.map((msg, index) => (
        <div
          key={msg._id || index}
          ref={(el) => (msgRefs.current[index] = el)}
        >
          <MessageBubble
            message={msg}
            highlightText={highlightText}
            isActive={index === activeMessageIndex}
          />
        </div>
      ))}
      <div ref={chatEndRef} />
    </div>
  );
}